module.exports = __webpack_public_path__ + "images/emoji/bug.a619523ac7b839d76dd1.png";